import { Injectable } from '@angular/core';
import { isUndefinedOrNullOrEmpty } from '../util';

/**
 * Shared formatting utilities for UI display.
 * Centralizes date and text transformations used across ag-grid column definitions
 * and other view models.
 */
@Injectable({ providedIn: 'root' })
export class FormattingService {
  /**
   * Formats a date-like value (string | number | Date) into MM-DD-YYYY.
   * Returns empty string if input is undefined/null/empty. Returns original value if invalid date.
   */
  public formatMmDdYyyy(value: unknown): string {
    if (isUndefinedOrNullOrEmpty(value)) { return ''; }
    const date: Date = new Date(value as any);
    if (isNaN(date.getTime())) { return String(value); }
    const mm: string = String(date.getMonth() + 1).padStart(2, '0');
    const dd: string = String(date.getDate()).padStart(2, '0');
    const yyyy: number = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  }

  /**
   * Capitalizes the first letter of each word in a string.
   * Returns empty string if input is undefined/null/empty.
   */
  public capitalizeWords(value: unknown): string {
    if (isUndefinedOrNullOrEmpty(value)) { return ''; }
    return String(value).replace(/\b\w/g, (c: string): string => c.toUpperCase());
  }
}
